var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 5C1.25 4.58579 1.58579 4.25 2 4.25H7.62786C8.39255 4.25 9.12271 4.5684 9.64304 5.12876L15.3271 11.25H20.1893L17.4697 8.53033C17.1768 8.23744 17.1768 7.76256 17.4697 7.46967C17.7626 7.17678 18.2374 7.17678 18.5303 7.46967L23.0607 12L18.5303 16.5303C18.2374 16.8232 17.7626 16.8232 17.4697 16.5303C17.1768 16.2374 17.1768 15.7626 17.4697 15.4697L20.1893 12.75H15.3271L9.64304 18.8712C9.12271 19.4316 8.39255 19.75 7.62786 19.75H2C1.58579 19.75 1.25 19.4142 1.25 19C1.25 18.5858 1.58579 18.25 2 18.25H7.62786C7.97545 18.25 8.30734 18.1053 8.54385 17.8506L13.9765 12L8.54385 6.14944C8.30734 5.89473 7.97545 5.75 7.62786 5.75H2C1.58579 5.75 1.25 5.41421 1.25 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default __webpack_public_path__ + "static/media/merge.a61b236220ce64f98f54ece264aea63a.svg";
export { ForwardRef as ReactComponent };